
const ERROR = {
  PROGRAM:
    "At least one of Atrial Fibrillation or other Arrhythmia Diagnosis must be selected to proceed",
};

const FORM_DIAGNOSIS_TITLE =
"To be eligible for KardiaComplete, you should have received at least one of the following diagnoses. Select all that apply."

const ACHQ_DIAGNOSIS_TITLE ="Please select any diagnoses that apply." 

export { ACHQ_DIAGNOSIS_TITLE, FORM_DIAGNOSIS_TITLE, ERROR };
